import styled, { css } from 'styled-components';
import statusSmallIcon_blue from 'static/images/icon/statusSmallIcon_blue.png';
import statusSmallIcon_warning from 'static/images/icon/statusSmallIcon_warning.png';
import statusSmallIcon_danger from 'static/images/icon/statusSmallIcon_danger.png';
import statusSmallIcon_none from 'static/images/icon/statusSmallIcon_none.png';

export const ModuleBox = styled.div`
  margin: 0;
  padding: 0.2rem 0.5rem;
  border-bottom: 0.5px #1f242c solid;
  color: #fff;
  cursor: pointer;
  display: flex;
  align-items: center;
  font-size: 18px;
  letter-spacing: -0.5px;
  text-align: left;

  &:hover {
    background: #1f242c;
  }

  & > div.systemLogContent {
    width: 170px;
    margin: 0 5px;
  }

  & > div.confirmBtn {
    display: flex;
    align-items: center;

    & > svg {
      width: 20px;
      height: 20px;
    }
  }
`

export const ModuleStatusImage = styled.img`
  width: 40px;

  ${props =>
    props.status === 'danger' ? css`content:url(${statusSmallIcon_danger});` : (
      props.status === 'warning' ? css`content:url(${statusSmallIcon_warning});` : (
        props.status === 'none' ? css`content:url(${statusSmallIcon_none});` : css`content:url(${statusSmallIcon_blue});`
      )
    ) 
  }
`